import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getTypeReviewRows = api(async function getTypeReviewRows(registerId) {
    return query(
        gql`
            query GetTypeReviewRows($registerId: String!) {
                getTypeReviewRows(registerId: $registerId) {
                    typeKey
                    originalAssetType
                    identifiedAsset
                    suggestedParent
                    suggestedTypeName
                    reviewedTypeName
                    reviewedParent
                    reviewStatus
                    count
                }
            }
        `,
        { registerId },
        { returns: "getTypeReviewRows" }
    )
})
